import { useAppContext } from "../../AppProvider";
import { responsiveCustomDatas } from "./Layout/ResponsiveCustomDatas";

export const CustomDataHeader = () => {
  const { dictionary, display } = useAppContext();

  const styles = responsiveCustomDatas(display);
  return (
    <>
      {(display.lg || display.xl || display.xxl) && (
        <>
          <div className="d-grid gap-2 px-2 mb-2" style={styles.header}>
            <div style={styles.cells.description}>
              <label className="label-2">
                {dictionary.registries.description}
              </label>
            </div>
            <div style={styles.cells.unitWeight}>
              <label className="label-2">
                {dictionary.dimensions.unit_weight + " (Kg)"}
              </label>
            </div>
            <div style={styles.cells.unitPrice}>
              <label className="label-2">
                {dictionary.dimensions.unit_value}
              </label>
            </div>
            <div style={styles.cells.hsCode}>
              <label className="label-2">
                {dictionary.customs_data.hs_code}
              </label>
            </div>
            <div style={styles.cells.countryIsoCode2}>
              <label className="label-2">
                {dictionary.customs_data.country_of_origin}
              </label>
            </div>
            <div style={styles.cells.quantity}>
              <label className="label-2">
                {dictionary.registries.quantity}
              </label>
            </div>
          </div>
        </>
      )}
    </>
  );
};
